import React from 'react'
import { Link } from 'react-router-dom'

export default function About() {
  return (
    <section className="section light" style={{ minHeight: '70vh' }}>
      <h2>Routing and Continuity Infrastructure for Outpatient Behavioral Health</h2>
      <p className="lead muted">
        We build the operational layer that helps health plans and provider organizations route patients
        to better-fit care, and see continuity risk before it becomes a dropout.
      </p>

      <div className="section-block">
        <div className="section-head"><h2>Why We Built ATUUNE</h2></div>
        <p className="lead muted">
          Referral and scheduling systems can tell you a referral was made and an appointment was booked.
          They rarely tell you whether a patient is still engaged three or four sessions later — or which
          patients are drifting away while there's still time to reach out. We built ATUUNE to close that
          specific operational gap, without asking health plans and provider organizations to replace the
          systems they've already invested in.
        </p>
      </div>

      <div className="cards">
        <div className="card">
          <h3>Mission</h3>
          <p>Help health plans and provider organizations route patients to better-fit care, and notice early when continuity is at risk.</p>
        </div>
        <div className="card">
          <h3>How it works</h3>
          <p>Structured intake produces a richer routing signal, with plain-language reasons behind every routing decision — never an unexplained score.</p>
        </div>
        <div className="card">
          <h3>What you pay for</h3>
          <p>Outcome-aligned pricing tied to a measurable operational milestone — a routed patient attending Session 4 — not a claim about clinical outcome.</p>
        </div>
      </div>

      <div className="section-block">
        <div className="section-head"><h2>Implementation</h2></div>
        <p className="lead muted">
          Implementation is scoped around your existing provider network and existing systems — see{' '}
          <Link to="/how-it-works">How It Works</Link> for the operational and architectural detail, and{' '}
          <Link to="/contact">request a demo</Link> for a timeline specific to your organization.
        </p>
      </div>

      <p className="legal-note">ATUUNE does not provide medical advice or therapy. Not for emergencies.</p>
    </section>
  )
}
